import React from "react";
import { createRoot } from "react-dom/client";
import Download from "./Download";

import "./Download.scss";

export interface DownloadOptions {
  type: string,
  registrantId?: string,
  dogId?: string,
  eventId?: string,
  showId?: string,
  showIds?: string[],
  armNumbers?: number[],
  scoreId?: string,
  transactionId?: string,
  showType?: string,
  showTypes?: string[],
  showElement?: string,
  showLevel?: string,
  showSection?: string,
  include_breed?: boolean,
  include_jump_height?: boolean,
  include_call_name?: boolean,
  labelsToSkip?: number,
  ring?: string,
  // UKC Conformation judge's books filtering options
  breed_filter_type?: string,
  breed_filters?: string[],
  breed_group_filters?: string[],
  builder_suffix?: string,
  small?: boolean,
  format_5162?: boolean,
  // AKC Herding scoresheets: include blank scoresheets for waitlisted
  // "-ALT" alternates
  include_alternates?: boolean,
  // UKC Nosework / Precision Coursing judge's books sort order
  judge_books_sort?: "run_order" | "placement" | "height_at_withers" | "armband",
  // Club contacts export
  clubId?: string,
  capacityFilters?: string[],
  // User ID for registration summary
  userId?: string,
  include_waitlist?: boolean,
  // Column selection for registrations export
  selectedColumns?: string[],
  // Course ID for course roster export
  courseId?: string,
}

export class DownloadManager {
  private containerRef: HTMLDivElement;
  private downloads: DownloadOptions[] = [];
  private downloadInterval: any;

  private root:any;

  constructor() {
    const body = document.getElementsByTagName("body")[0] as HTMLBodyElement;
    const downloadContainer = document.createElement("div") as HTMLDivElement;
    downloadContainer.id = "download-container-main";
    body.insertAdjacentElement("afterbegin", downloadContainer);
    this.containerRef = downloadContainer;
    this.root = createRoot(this.containerRef);
  }

  public pushDownload(options: DownloadOptions): void {
    this.downloads.push(options);
    this.render();
  }

  public shiftDownload(): void {
    this.downloads.shift();
    this.render();
  }

  public destroy(): void {
    this.render();
  }

  private render(): void {
    const downloadContent = <Download files={this.downloads} />;
    this.root.render(downloadContent);
  }
}

export const download = new DownloadManager();